function onCartView() {
  const productsInCart = document.querySelectorAll('[id^="CartDrawer-Item-"]');
  if (!productsInCart.length) return;
  
  const products = Array.from(productsInCart).map((productInCart) => {
    const productScriptTag = productInCart.querySelector('[id^="Product-Item-Data-"]');
  
    return {
      data: productScriptTag ? JSON.parse(productScriptTag.innerHTML) : {},
      section: {
        item_list_id: "cart-drawer-items",
        item_list_name: "Products in cart"
      }
    };
  });
  
  const items = products.map((product) => ({...product.data, ...product.section}));
  
  const ecommerceScriptTag = document.querySelector('[id^="Ecommerce-Cart-Data-"]');
  const ecommerceData = ecommerceScriptTag ? JSON.parse(ecommerceScriptTag.innerHTML) : {};
  
  /* Push to dataLayer */
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_cart',
    ecommerce: {
      items,
      ...ecommerceData
    },
  });
  
  console.log('%cEvent: view_cart', 'color: #FF9100');
  console.log(window.dataLayer);
}

document.addEventListener('CartView', onCartView);

if (window.page_type === 'cart') {
  onCartView();
}
